import {createAction, props} from '@ngrx/store';

export const addTrackIdsToSongUIAction = createAction('[Song UI] Add Tracks', props<{trackIds: string[]}>());
export const expandAllTracksSongUi = createAction('[Song UI] Expand Tracks');
export const collapseAllTracksSongUi = createAction('[Song UI] Collapse Tracks');
export const toggledTrackExpandedSongUi = createAction('[Song UI] Toggle Track Expanded', props<{trackId: string}>());
